import { assignUserTaskGroups } from '@dispatch/shared/services';
import { useMutation, useQueryClient } from 'react-query';

export const useAssignUserTaskGroups = (
  userId: string,
  onError: () => void
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['assign-user-task-groups', userId],
    async (data: string[]) => assignUserTaskGroups(userId, data),
    {
      onError,
      onSettled: () => {
        if (userId) {
          client.invalidateQueries('task-groups');
        }
      },
    }
  );

  return {
    assignUserTaskGroups: mutate,
    error,
    status,
  };
};
